import React from 'react';
import HeadingSection from '../../components/HeadingSection';
import './style.css';

const LogsLayout = ({
  title,
  subTitle,
  backTo,
  backToLastPath,
  tooltip,
  metricType,
  headerChildren,
  metrics,
  children,
  ...props
}) => (
  <main className="logs-layout">
    <HeadingSection
      title={title}
      backTo={backTo}
      backToLastPath={backToLastPath}
      subTitle={subTitle}
      tooltip={tooltip}
      metrics={metrics}
      {...props}
    >
      {headerChildren}
    </HeadingSection>
    {children}
  </main>
);

export default LogsLayout;
